import { ArrowLeft, Mail } from 'lucide-react';
import { useNavigate } from 'react-router';
import { MarkdownContent } from '../components/MarkdownContent';
import { SUPPORT_EMAIL } from '../config/publicResources';
import accountDeletion from '../content/legal/account-deletion.md?raw';
import { useApp } from '../context/AppContext';

const TITLE = 'Delete your Rubikoo Conference App account';
const CONTENT = accountDeletion.replace(/^# .+\r?\n+/, '');
const DELETION_SUBJECT = 'Rubikoo Conference App account deletion request';

export default function AccountDeletionScreen() {
  const navigate = useNavigate();
  const { isAuthenticated } = useApp();
  const deletionMailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(DELETION_SUBJECT)}`;

  return (
    <main className="size-full overflow-y-auto pb-16" style={{ background: 'var(--app-bg)' }}>
      <header className="app-screen-header px-5 pb-3">
        <button
          type="button"
          aria-label="Go back"
          onClick={() => navigate(-1)}
          className="size-10 rounded-full flex items-center justify-center"
          style={{ background: 'var(--app-surface)', color: 'var(--app-text)' }}
        >
          <ArrowLeft className="size-5" aria-hidden="true" />
        </button>
      </header>
      <article className="px-5">
        <h1 className="text-3xl tracking-tight mb-6" style={{ color: 'var(--app-text)' }}>
          {TITLE}
        </h1>
        <MarkdownContent content={CONTENT} />
        <div className="mt-8 flex flex-col gap-3">
          <a
            href={deletionMailto}
            className="min-h-12 px-4 rounded-xl flex items-center justify-center gap-2 text-center text-white"
            style={{ background: 'var(--app-accent-solid)' }}
          >
            <Mail className="size-4" aria-hidden="true" />
            Email an account deletion request
          </a>
          <p className="text-sm select-text" style={{ color: 'var(--app-text-muted)' }}>
            Contact: {SUPPORT_EMAIL}
          </p>
          {isAuthenticated && (
            <button
              type="button"
              onClick={() => navigate('/profile')}
              className="h-12 rounded-xl border"
              style={{ borderColor: 'var(--app-border)', color: 'var(--app-text)' }}
            >
              Return to Profile
            </button>
          )}
        </div>
      </article>
    </main>
  );
}
